import { BreadcrumbList, ListItem } from 'schema-dts';

export type Breadcrumb = {
  name: string;
  url: string;
};

export const HOME_BREADCRUMB: Breadcrumb = {
  name: 'Home',
  url: 'https://www.udacity.com/',
};

export const CATALOG_BREADCRUMB: Breadcrumb = {
  name: 'Catalog',
  url: 'https://www.udacity.com/catalog',
};

// Builds a Home-first BreadcrumbList with 1-based sequential positions. The crumb URL is
// carried on `item['@id']`, which Google treats as the canonical URL for the list item.
export function createBreadcrumbStructuredData(crumbs: Breadcrumb[]): BreadcrumbList {
  const itemListElement: ListItem[] = crumbs.map(({ name, url }, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name,
    item: {
      '@id': url,
    },
  }));

  return {
    '@type': 'BreadcrumbList',
    itemListElement,
  };
}
